import type { FLIGHTS_TAB } from '../../helpers/constants/analyticsConstants';

export type CalendarTab = typeof FLIGHTS_TAB;
export type ComponentTrackingConfig = {
  componentName: InstrumentedComponent;
  vertical: Vertical;
  calendarTab: CalendarTab;
};

export type ComboRecommendationTrackingConfig = {
  componentName: 'combo_recommendation';
  stringProperties?: Record<string, string>;
  numericProperties?: Record<string, number>;
  booleanProperties?: Record<string, boolean>;
};

export const clickInteractionType = 1;
export const unsetInteractionType = 0;

export type MBDEvent = MBDImpressionEvent | MBDInteractionEvent;

type InstrumentedComponent = 'month_view_explore_card' | 'combo_recommendation';
type Vertical = 'hotel' | 'car_hire' | 'flights' | 'hotels';
type InteractionType =
  typeof clickInteractionType | typeof unsetInteractionType;

type MBDImpressionEvent = {
  view_guid: string;
  common: {
    component_name: InstrumentedComponent;
    numeric_properties: Record<string, number>;
    string_properties: Record<string, string>;
    boolean_properties: Record<string, boolean>;
  };
};

type MBDInteractionEvent = {
  element_impression_guid: string;
  interaction_type: InteractionType;
  common: {
    component_name: InstrumentedComponent;
    numeric_properties: Record<string, number>;
    string_properties: Record<string, string>;
    boolean_properties: Record<string, boolean>;
  };
};
